import React from 'react'
import Dropdown from '../../components/Dropdown'
export default () => (
  <Dropdown />
)